import { call, fork, put, takeLatest } from "redux-saga/effects";

import { GET_STAFF_LEAVE_TYPE, GET_STAFF_LEAVE_LIST } from "./actionType";

import {
  getStaffLeaveListSuccess,
  getStaffLeaveListError,
  getStaffLeaveTypeSuccess,
  getStaffLeaveTypeError,
} from "./action";

import {
  getStaffLeaveList,
  getStaffLeaveTypeList,
} from "../../helpers/fakebackend_helper";

function* fetchStaffLeaveList() {
  try {
    const staffLeaveList = yield call(getStaffLeaveList);
    yield put(getStaffLeaveListSuccess(staffLeaveList));
  } catch (error) {
    yield put(getStaffLeaveListError(error));
  }
}

function* watchFetchStaffLeaveList() {
  yield takeLatest(GET_STAFF_LEAVE_LIST, fetchStaffLeaveList);
}

function* fetchStaffLeaveType() {
  try {
    const staffLeaveType = yield call(getStaffLeaveTypeList);
    yield put(getStaffLeaveTypeSuccess(staffLeaveType));
  } catch (error) {
    yield put(getStaffLeaveTypeError(error));
  }
}

function* watchFetchStaffLeaveType() {
  yield takeLatest(GET_STAFF_LEAVE_TYPE, fetchStaffLeaveType);
}

// main saga function

function* CalendarCrmITSaga() {
  yield fork(watchFetchStaffLeaveList);
  yield fork(watchFetchStaffLeaveType);
}

export default CalendarCrmITSaga;
